var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20033,
    height: 14989,
    viewBox: "0 0 20033 14989",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10016.1 14989C15547.8 14989 20032.1 14758 20032.1 14473.1C20032.1 14188.2 15547.8 13957.3 10016.1 13957.3C4484.45 13957.3 0.134766 14188.2 0.134766 14473.1C0.134766 14758 4484.45 14989 10016.1 14989Z",
    fill: "#252B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10015.7 1C9163.2 811.88 6982.72 1631.08 4440 3368.68C4440 3368.68 4598.72 9240.04 10015.7 12449.6V1Z",
    fill: "#FFD700",
    stroke: "#252B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10015.7 1C10867.5 811.88 13048.6 1631.08 15591.4 3368.68C15591.4 3368.68 15432.6 9240.04 10015.7 12449.6V1Z",
    fill: "#252B34",
    stroke: "#252B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10015.7 500.84C8987.2 1229.8 7204.8 1924.84 4848.96 3534.44C4848.96 3534.44 4996.16 8974.44 10015.7 11949.8C15035.2 8975.72 15182.4 3534.44 15182.4 3534.44C12825.9 1925.48 11051.8 1229.8 10015.7 500.84Z",
    fill: "#252B34",
    stroke: "#252B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14301.8 2956.52C10707.5 4044.52 7965.76 7202.92 6719.04 8868.84C7576.62 10126.9 8702.53 11179.2 10015.7 11949.8C15035.2 8975.72 15182.4 3534.44 15182.4 3534.44C14879 3327.93 14585.5 3135.29 14301.8 2956.52Z",
    fill: "#FFD700",
    stroke: "#252B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11972.8 5986.28H8119.36C8034.49 5986.28 7953.1 5952.57 7893.09 5892.56C7833.07 5832.54 7799.36 5751.15 7799.36 5666.28V3852.52C7809.3 3263.56 8050.25 2702.08 8470.27 2289.09C8890.29 1876.1 9455.75 1644.67 10044.8 1644.67C10633.8 1644.67 11199.3 1876.1 11619.3 2289.09C12039.4 2702.08 12280.3 3263.56 12290.2 3852.52V5666.28C12290.2 5750.71 12256.9 5831.72 12197.4 5891.66C12138 5951.59 12057.2 5985.61 11972.8 5986.28ZM8441.92 5346.28H11652.8V3852.52C11644.4 3432.28 11471.6 3032.09 11171.4 2737.86C10871.2 2443.63 10467.7 2278.82 10047.4 2278.82C9627.04 2278.82 9223.47 2443.63 8923.31 2737.86C8623.14 3032.09 8450.31 3432.28 8441.92 3852.52V5346.28Z",
    fill: "white",
    stroke: "#252B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12466.9 5112.04H7564.48V9254.76H12466.9V5112.04Z",
    fill: "white",
    stroke: "#252B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10525.1 6832.36C10525.1 6738.02 10500.1 6645.36 10452.6 6563.82C10405.2 6482.28 10336.9 6414.79 10254.9 6368.21C10172.9 6321.62 10079.9 6297.62 9985.58 6298.64C9891.24 6299.66 9798.86 6325.67 9717.84 6374.02C9636.82 6422.36 9570.07 6491.32 9524.37 6573.87C9478.68 6656.41 9455.68 6749.59 9457.73 6843.92C9459.77 6938.24 9486.77 7030.34 9535.99 7110.83C9585.21 7191.32 9654.89 7257.33 9737.92 7302.12L9648.32 8242.92H10334.4L10244.8 7302.12C10329.6 7256.5 10400.5 7188.72 10449.9 7105.99C10499.3 7023.27 10525.3 6928.7 10525.1 6832.36Z",
    fill: "#252B34",
    stroke: "#252B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.54a75f97e7f03346bfeee7b2473a00af.svg";
export { ForwardRef as ReactComponent };